import * as React from 'react';
import { tv, type VariantProps } from '@benepass/tailwind-config-web/tailwind-variants';
import { cn } from '../../utils';
import Primitive from '../primitives';

const triggerStyles = tv({
  base: [
    'cursor-pointer',
    'inline-flex items-center justify-center',
    'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-grayscale-20',
  ],
});

export type TriggerProps = Omit<React.ComponentPropsWithoutRef<typeof Primitive.Dialog.Trigger>, 'className'> &
  VariantProps<typeof triggerStyles>;

const Trigger: React.ForwardRefExoticComponent<
  TriggerProps & React.RefAttributes<React.ElementRef<typeof Primitive.Dialog.Trigger>>
> = React.forwardRef<React.ElementRef<typeof Primitive.Dialog.Trigger>, TriggerProps>(({ ...props }, ref) => (
  <Primitive.Dialog.Trigger ref={ref} className={cn(triggerStyles({}))} {...props} />
));

Trigger.displayName = 'Modal.Trigger';

export default Trigger;
